import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { pricing } from '../../utility/pricing'

function Pricing() {
    return (
        <section className="section-price padding-tb-100 bg-market">
            <div className="container">
                <div className="row">
                    <Fade triggerOnce duration={1500} direction='up' className="zx-app-banner" >
                        <h4 className="center">Pricing</h4>
                        <h2 className="center">Get in Reasonable Price</h2>
                    </Fade>
                    <Fade triggerOnce duration={1000} direction='up' className="col-lg-4 col-sm-12 main-plan" >
                        {
                            pricing.map((data, index) => (
                                <div key={index} className="zx-app-plans">
                                    <h4>{data.title}</h4>
                                    <div className="zx-app-body">
                                        <div className="zx-app-month">
                                            <h5>
                                                <span className="text-color">$</span>
                                                <code className="text-color">{data.price}</code> per month
                                            </h5>
                                        </div>
                                        <button type="submit" className="zx-app-plans-buttons">
                                            Get started
                                        </button>
                                        <div className="zx-app-seo">
                                            <p><code className="text-color">*</code>{data.space}</p>
                                            <p><code className="text-color">*</code>{data.domains}</p>
                                            <p><code className="text-color">*</code>{data.email_account}</p>
                                            <p><code className="text-color">*</code>{data.license}</p>
                                            <p><code className="text-color">*</code>{data.technical_support}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }

                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Pricing
